import wait from '@afosto/utils/wait';
import { queue as queueApi } from '@afosto/spooler/api/Queue';

const MAX_PRINT_ATTEMPTS = 30;
const POLL_INTERVAL = 1000;
const PENDING_STATUS = 'pending';
const FAILED_STATUS = 'failed';
const CANCELLED_STATUS = 'cancelled';

const pollJobStatus = async (reference, attempts = 0, config = {}) => {
  try {
    const maxPrintAttempts = config?.maxPrintAttempts ?? MAX_PRINT_ATTEMPTS;
    const pollInterval = config?.pollInterval ?? POLL_INTERVAL;

    if (attempts === maxPrintAttempts) {
      return Promise.reject(new Error('Too many attempts'));
    }

    await wait(pollInterval);

    const response = await queueApi.getJobStatus(reference);
    const { data } = response;
    const { status = PENDING_STATUS } = data;

    if (status === PENDING_STATUS) {
      return pollJobStatus(reference, attempts + 1, config);
    }

    if (status === FAILED_STATUS) {
      return Promise.reject(new Error('Job failed'));
    }

    if (status === CANCELLED_STATUS) {
      return Promise.reject(new Error('Job cancelled'));
    }

    return status;
  } catch (err) {
    return Promise.reject(err);
  }
};

export default pollJobStatus;
